import { Check, ImageIcon } from "lucide-react";
import { api } from "../../lib/api";

export const todayJst = () => new Intl.DateTimeFormat("sv-SE", { timeZone: "Asia/Tokyo" }).format(new Date());
export const addDays = (iso, days) => {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
};

export const fetchAutofill = (projectId) => api.get("/admin/estimates/autofill", { params: projectId ? { project_id: projectId } : {} }).then((r) => r.data);

export const surveyBlock = (note) => (note ? `【現地調査】\n${note}` : "");
export const mergeNotes = (base, note) => {
  const block = surveyBlock(note);
  if (!block || (base || "").includes(note)) return base || "";
  return [base, block].filter(Boolean).join("\n");
};
export const stripBlock = (notes, block) => (block ? (notes || "").replace(`\n${block}`, "").replace(block, "") : notes || "");
export const defaultPhotoIds = (photos) => photos.filter((p) => p.guide_id).slice(0, 12).map((p) => p.id);

export const applySuggestion = (item, name, suggestions) => {
  const hit = suggestions.find((s) => s.name === name);
  if (!hit) return { ...item, name };
  return {
    ...item,
    name,
    spec: item.spec || hit.spec || "",
    unit: item.unit || hit.unit || "",
    unit_price: Number(item.unit_price) ? item.unit_price : hit.unit_price || 0,
  };
};

export const ItemSuggestions = ({ items }) => (
  <datalist id="estimate-item-suggestions" data-testid="estimate-item-suggestions">
    {items.map((s) => <option key={s.name} value={s.name}>{[s.spec, s.unit, s.unit_price ? `¥${Number(s.unit_price).toLocaleString()}` : ""].filter(Boolean).join(" / ")}</option>)}
  </datalist>
);

const imgUrl = (id) => `${api.defaults.baseURL}/site-photos/${id}/image`;

export const EstimatePhotoPicker = ({ photos, value, onChange }) => {
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : value.length >= 12 ? value : [...value, id]);
  return (
    <div data-testid="estimate-photo-picker" className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] text-gray-500"><ImageIcon className="h-3.5 w-3.5" />添付する写真（PDFの2ページ目以降・最大12枚）</span>
        <span data-testid="estimate-photo-count" className="text-xs text-gray-400">{value.length}枚選択</span>
      </div>
      {photos.length === 0 ? <p className="text-xs text-gray-600">この案件の写真はまだありません</p> : (
        <div className="grid grid-cols-4 gap-2 sm:grid-cols-6">
          {photos.map((p) => {
            const on = value.includes(p.id);
            return (
              <button type="button" key={p.id} data-testid={`estimate-photo-${p.id}`} aria-pressed={on} onClick={() => toggle(p.id)} className={`relative aspect-square overflow-hidden border-2 transition-colors ${on ? "border-accent" : "border-transparent opacity-60 hover:opacity-100"}`}>
                <img src={imgUrl(p.id)} alt={p.title} className="h-full w-full object-cover" />
                {p.guide_no && <span className="absolute left-1 top-1 rounded-full bg-ink/80 px-1.5 font-mono text-[10px] text-accent">{p.guide_no}</span>}
                {on && <span className="absolute right-1 top-1 rounded-full bg-accent p-0.5 text-ink"><Check className="h-3 w-3" /></span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
